import { ButtonGroup, IconButton } from '@dixa/lib-shared-habla';
import type {
  ChartInstrumentVisualization as ChartInstrumentVisualizationT,
  InstrumentPanel,
} from 'lib-analytics-types';
import { ampli } from 'lib-shared-tracking';
import { memo } from 'react';

import { useAnalyticsState } from 'app/views/layout/views/analytics/components/panels/utils/useAnalyticsState/useAnalyticsState';

import { visualizationIcons } from '../../utils/appearance';

type ChartInstrumentVisualizationProps = {
  /** The containing panel. */
  panel: InstrumentPanel;
  /** The current visualization. */
  visualization: ChartInstrumentVisualizationT;
  /** The handler to change the visualization. */
  onChangeVisualization: (visualization: ChartInstrumentVisualizationT) => void;
};

const visualizations: ChartInstrumentVisualizationT[] = ['bar', 'line'];

export const ChartInstrumentVisualization = memo(
  function ChartInstrumentVisualization({
    panel,
    visualization,
    onChangeVisualization,
  }: ChartInstrumentVisualizationProps): JSX.Element {
    const { dashboard } = useAnalyticsState();

    return (
      <ButtonGroup variant="secondary">
        {visualizations.map((item) => (
          <IconButton
            key={item}
            icon={visualizationIcons[item]}
            onClick={() => {
              onChangeVisualization(item);

              ampli.analyticsChartVisualizationChanged({
                visualization: item,
                panel: panel.title,
                dashboard: dashboard.title,
              });
            }}
            active={visualization === item}
          />
        ))}
      </ButtonGroup>
    );
  },
);
